import Image from './image'

const Logo = (): JSX.Element => (
  <div className="btn header-button">
    <Image />
  </div>
)

export default Logo
